import * as yup from 'yup';

import localizedStrings from 'localization';

export const addUserOptionValidationSchema = yup.object().shape({
  userValue: yup.string().required(localizedStrings.optionRequired),
});
